<template>
  <div class="parentx">
    <vs-sidebar ref="mainSidebar" :parent="parent" :hiddenBackground="clickNotClose" :reduce="reduce" default-index="-1"
                class="sidebarx main-menu-sidebar items-no-padding" v-model="isSidebarActive"
                :click-not-close="clickNotClose" :reduce-not-rebound="reduceNotRebound">
      <div @mouseenter="sidebarMouseEntered" @mouseleave="sidebarMouseLeave">
        <div class="header-sidebar flex items-end justify-between" slot="header">
          <div class="logo flex items-center" :class="{ 'justify-center w-full': reduce && !isMouseEnter }">
            <img :src="logo" alt="logo" :class="reduce && !isMouseEnter ? 'mx-auto' : 'mr-4'" style="width: 250px !important; height: 70px !important; object-fit: contain;" v-if="logo">
            <span class="logo-text" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span>
          </div>
          <div style="margin-bottom: 13px;" v-if="showCloseButton">
            <feather-icon icon="XIcon" class="m-0 cursor-pointer"
                          @click.stop="$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)"></feather-icon>
          </div>
        </div>

        <div class="shadow-bottom" v-show="showShadowBottom"></div>

        <component
          :is="scrollWrapperComponent"
          ref="mainSidebarPs"
          :class="scrollAreaClass"
          v-bind="scrollWrapperProps"
          v-on="scrollWrapperListeners"
        >
          <template v-for="(sidebarItem, index) in sidebarItems">

            <!-- GROUP ITEM HEADER -->
            <span :key="`header-${index}`" v-if="sidebarItem.header && !sidebarItemsMin"
                  class="navigation-header truncate">{{ $t(sidebarItem.i18n) || sidebarItem.header }}</span>
            <template v-else-if="!sidebarItem.header">

              <!-- IF IT'S SINGLE ITEM -->
              <vx-sidebar-item ref="sidebarLink" :key="`sidebarItem-${index}`" v-if="!sidebarItem.submenu"
                               :index="index" :to="sidebarItem.slug != 'external' ? sidebarItem.url : ''"
                               :href="sidebarItem.slug == 'external' ? sidebarItem.url : ''" :icon="sidebarItem.icon"
                               :target="sidebarItem.target" :isDisabled="sidebarItem.isDisabled">
                <span v-show="!sidebarItemsMin" class="truncate">{{ $t(sidebarItem.i18n) || sidebarItem.name }}</span>
                <vs-chip class="ml-auto" :color="sidebarItem.tagColor"
                         v-if="sidebarItem.tag && (isMouseEnter || !reduce)">{{ sidebarItem.tag }}
                </vs-chip>
              </vx-sidebar-item>

              <!-- IF HAVE SUBMENU / DROPDOWN -->
              <template v-else>
                <vx-sidebar-group ref="sidebarGrp" :key="`group-${index}`" :openHover="openGroupHover"
                                  :group="sidebarItem" :groupIndex="index"
                                  :open="isGroupActive(sidebarItem)"></vx-sidebar-group>
              </template>
            </template>
          </template>
          
          <!-- Logout Section with spacing from menu -->
          <div class="logout-wrapper mt-8 mb-4">
            <!-- Full logout when sidebar expanded -->
            <div class="logout-section p-4 border-t border-gray-200" v-show="isMouseEnter || !reduce">
              <div class="flex items-center cursor-pointer hover:bg-gray-100 p-2 rounded-lg transition-colors" @click="logout">
                <feather-icon icon="LogOutIcon" class="mr-3" svgClasses="w-5 h-5 text-red-500"></feather-icon>
                <span class="text-gray-700 font-medium">Logout</span>
              </div>
            </div>
            
            <!-- Icon-only logout when sidebar reduced -->
            <div class="logout-icon-only p-2 text-center border-t border-gray-200" v-show="reduce && !isMouseEnter">
              <vs-tooltip text="Logout">
                <div class="cursor-pointer hover:bg-red-50 p-2 rounded-lg transition-colors" @click="logout">
                  <feather-icon icon="LogOutIcon" svgClasses="w-5 h-5 text-red-500 mx-auto"></feather-icon>
                </div>
              </vs-tooltip>
            </div>
          </div>
        </component>
        
        <!-- Minimize/Expand feature disabled for now -->
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VxSidebarGroup from './VxSidebarGroup.vue';
import VxSidebarItem from './VxSidebarItem.vue';

export default {
  name: 'vx-sidebar',
  props: {
    sidebarItems: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
    },
    logo: {
      type: String
    },
    parent: {
      type: String
    },
    openGroupHover: {
      type: Boolean,
      default: false
    },
    reduceNotRebound: {
      type: Boolean,
      default: true,
    }
  },
  data: () => ({
    clickNotClose: false, // disable close sidebar on outside click
    reduce: false, // determines if sidebar is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    isMouseEnter: false,
    settings: { // perfectscrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true
    },
    windowWidth: window.innerWidth, //width of windows
    showShadowBottom: false,
    useNativeScrollbar: window.innerWidth < 992,
    justOpened: false, // prevent immediate closing after opening
    isTouchDevice: false, // detect if device has touch capability
  }),
  computed: {
    scrollWrapperComponent() {
      return this.useNativeScrollbar ? 'div' : 'VuePerfectScrollbar'
    },
    scrollWrapperProps() {
      return this.useNativeScrollbar ? {} : { settings: this.settings }
    },
    scrollWrapperListeners() {
      return this.useNativeScrollbar
        ? { scroll: this.psSectionScroll }
        : { 'ps-scroll-y': this.psSectionScroll }
    },
    scrollAreaClass() {
      return [
        'scroll-area--main-sidebar',
        'pt-2',
        { 'native-scroll': this.useNativeScrollbar }
      ]
    },
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive
      },
      set(val) {
        // Prevent immediate closing after opening on mobile
        if (val === false && this.justOpened) {
          return
        }

        // IMPORTANT: Block auto-opening on touch devices with desktop viewport
        // This prevents sidebar from auto-opening when clicking inputs/filters on mobile with desktop mode
        const isTouchDevice = this.isTouchDevice // Use cached value instead of calling detectTouchDevice()
        const userTriggered = this.$store.state.sidebarUserTriggered

        // Enhanced blocking logic for mobile with desktop mode:
        // 1. Block if touch device regardless of window width (unless user triggered)
        // 2. Also block if window width < 1200 (unless user triggered)
        if (val === true && !userTriggered) {
          if (isTouchDevice || this.windowWidth < 1200) {
            // Block auto-opening unless user explicitly clicked hamburger menu
            console.log('[Sidebar] Blocked auto-open on touch device or mobile viewport')
            return
          }
        }

        // Reset user triggered flag after use
        if (userTriggered) {
          this.$store.commit('SET_SIDEBAR_USER_TRIGGERED', false)
        }

        // Use Vue's nextTick for better state management
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', val)

          // If opening sidebar, set flag and clear it after a short delay
          if (val === true && this.windowWidth < 1200) {
            this.justOpened = true
            setTimeout(() => {
              this.justOpened = false
            }, 300)
          }
        })
      }
    },
    reduceSidebar() {
      return Boolean(this.reduce && this.reduceButton)
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val)
      }
    },
    sidebarItemsMin() {
      return this.$store.state.sidebarItemsMin;
    },
    isGroupActive() {
      return (sidebarItem) => {
        const path = this.$route.fullPath;
        let open = false;
        let func = function (sidebarItem) {
          if (sidebarItem.submenu) {
            sidebarItem.submenu.forEach((item) => {
              if (path == item.url) {
                open = true
              } else if (item.submenu) {
                func(item)
              }
            })
          }
        }
        func(sidebarItem)
        return open
      }
    },
  },
  watch: {
    reduce(val) {
      if (val == true) {
        this.$store.dispatch('updateSidebarWidth', 'reduced');
      } else {
        this.$store.dispatch('updateSidebarWidth', 'default');
      }

      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    },
    reduceButton() {
      this.setSidebarWidth();
    },
    '$route'() {
      if (this.isSidebarActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },
  },
  methods: {
    detectTouchDevice() {
      // Detect if device has touch capability
      return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      )
    },
    sidebarMouseEntered() {
      if (this.reduce) this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
      this.isMouseEnter = true;
    },
    sidebarMouseLeave() {
      if (this.reduce) {
        this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true);
      }
      this.isMouseEnter = false;
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setSidebarWidth();
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      this.useNativeScrollbar = this.windowWidth < 992

      // Use cached touch device detection
      const isTouchDevice = this.isTouchDevice

      // Mobile and Tablet - sidebar as overlay
      // Also treat touch devices as mobile even if windowWidth >= 1200 (desktop mode on mobile)
      if (this.windowWidth < 1200 || (isTouchDevice && this.windowWidth >= 1200)) {
        if (this.windowWidth < 992) this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'md')
        else this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'lg')

        // Mobile/Tablet settings
        if (this.reduceButton) this.reduce = false;
        this.showCloseButton = true;
        this.clickNotClose = false; // Allow closing when clicking outside on mobile
        this.$store.dispatch('updateSidebarWidth', 'no-sidebar')
        this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)

        // Important: Don't force close sidebar on resize in mobile
        // Let user control it via hamburger menu
      } else {
        // Desktop - permanent sidebar (only for non-touch devices)
        this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'xl')
        if (this.reduceButton) this.reduce = true;
        else this.reduce = false;

        // Only auto-open sidebar on desktop if it's a real desktop (not touch device)
        // This prevents auto-opening on touch devices with desktop viewport
        if (!this.$store.state.isSidebarActive && !isTouchDevice) {
          this.$store.commit('SET_SIDEBAR_USER_TRIGGERED', true) // Mark as user action to allow opening
          this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true)
        }

        if (this.reduceButton && !this.isMouseEnter) this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true)
        else this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)

        this.clickNotClose = true;
        this.showCloseButton = false;
        if (this.reduceButton)
          this.$store.dispatch('updateSidebarWidth', 'reduced')
        else
          this.$store.dispatch('updateSidebarWidth', 'default')
      }
    },
    psSectionScroll(event) {
      let scrollTop = 0
      if (this.useNativeScrollbar) {
        scrollTop = event && event.target ? event.target.scrollTop : 0
      } else if (this.$refs.mainSidebarPs && this.$refs.mainSidebarPs.$el) {
        scrollTop = this.$refs.mainSidebarPs.$el.scrollTop
      }

      if (scrollTop > 0) this.showShadowBottom = true
      else this.showShadowBottom = false
    },
    logout() {
      // Clear user data from localStorage
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userData')
      localStorage.removeItem('token')
      localStorage.removeItem('expired')
      localStorage.removeItem('userRole')
      
      // Show logout notification
      this.$vs.notify({
        title: 'Logout',
        text: 'You have been logged out successfully',
        color: 'success',
        position: 'top-right'
      })
      
      // Redirect to login page
      this.$router.push('/pages/login')
    },
  },
  components: {
    VxSidebarGroup,
    VxSidebarItem,
    VuePerfectScrollbar,
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    // Detect touch device on mount
    this.isTouchDevice = this.detectTouchDevice();
    this.setSidebarWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxSidebar.scss";

// Fixed bottom section
.bottom-section-fixed {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: inherit;
}

// Custom styles for logout section (inside scroll area)
.logout-wrapper {
  .logout-section {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    margin: 0 8px;
    
    .flex {
      transition: all 0.3s ease;
      border-radius: 12px;
      margin: 4px;
      color: rgba(255, 255, 255, 0.8);
      
      &:hover {
        background-color: rgba(220, 38, 38, 0.2) !important;
        border-radius: 12px;
        transform: translateX(2px);
        box-shadow: 0 2px 8px rgba(220, 38, 38, 0.2);
        
        .feather-icon svg {
          color: #ef4444 !important;
        }
        
        span {
          color: #ef4444 !important;
          font-weight: 600;
        }
      }
    }
  }
  
  .logout-icon-only {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    margin: 0 8px;
    
    > div {
      transition: all 0.3s ease;
      border-radius: 12px;
      margin: 4px;
      
      &:hover {
        background-color: rgba(220, 38, 38, 0.2) !important;
        box-shadow: 0 2px 8px rgba(220, 38, 38, 0.2);
        
        .feather-icon svg {
          color: #ef4444 !important;
        }
      }
    }
  }
}

// Minimize/expand CSS disabled
.bottom-section-fixed-disabled {
  .minimize-section,
  .expand-section {
    margin: 0 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    
    .flex {
      transition: all 0.3s ease;
      border-radius: 12px;
      margin: 4px;
      color: rgba(255, 255, 255, 0.8);
      
      &:hover {
        background-color: rgba(255, 255, 255, 0.1) !important;
        border-radius: 12px;
        transform: translateX(2px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        
        .feather-icon svg {
          color: rgba(255, 255, 255, 0.9) !important;
        }
        
        span {
          color: white !important;
          font-weight: 600;
        }
      }
    }
  }
  
  .expand-icon-only {
    margin: 0 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    
    > div {
      transition: all 0.3s ease;
      border-radius: 12px;
      margin: 4px;
      
      &:hover {
        background-color: rgba(255, 255, 255, 0.1) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        
        .feather-icon svg {
          color: rgba(255, 255, 255, 0.9) !important;
        }
      }
    }
  }
}

// Center logo when sidebar is reduced
.parentx .sidebarx {
  .header-sidebar {
    .logo {
      transition: all 0.3s ease;
      
      &.justify-center {
        img {
          margin: 0 !important;
        }
      }
    }
  }
}
</style>
